"use strict";
/**
 * @module
 * @internal
* */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFormat = void 0;
var compose_1 = __importDefault(require("lodash/fp/compose"));
var replace_1 = __importDefault(require("lodash/fp/replace"));
var parseFormat = function (format) { return (0, compose_1.default)((0, replace_1.default)(/E/g, 'd'), (0, replace_1.default)(/y/g, 'Y'), (0, replace_1.default)(/d/g, 'D'))(format); };
exports.parseFormat = parseFormat;
